/* ======================
   CORE
====================== */


import {getCMSCache} from "./cmsStorage";

function getCMSData() {
    return getCMSCache()?.data || null;
}

export function getCMSLastUpdated() {
    return getCMSCache()?.lastUpdated || null;
}

/* ======================
   GENERAL
====================== */

export function getCMSGeneral() {
    return getCMSData()?.general || null;
}

export function getCompanyInfo() {
    const g = getCMSGeneral();
    if (!g) return null;

    return {
        name: g.companyName,
        shortName: g.companyShortname,
        founder: g.founder,
        founderTitle: g.founderTitle,
        motto: {
            id: g.mottoId,
            en: g.mottoEn,
        },
        vision: {
            id: g.visionId,
            en: g.visionEn,
        },
        mission: {
            id: g.missionId,
            en: g.missionEn,
        },
    };
}

export function getCMSContact() {
    return getCMSGeneral()?.contact || null;
}

export function getOfficeList() {
    return getCMSContact()?.office || [];
}

/* ======================
   ASSETS
====================== */

export function getCMSAssets() {
    return getCMSData()?.assets || {};
}

export function getBanner(type) {
    return getCMSAssets()?.[type] || null;
}

/* ======================
   SERVICES
====================== */

export function getServices() {
    return getCMSData()?.services || [];
}

/* ======================
   PORTFOLIO
====================== */

export function getPortfolios() {
    return getCMSData()?.portfolio || [];
}

export function getPortfolioByServiceTag(serviceId) {
    return getPortfolios().filter(p => p.tags?.includes(serviceId));
}

/* ======================
   BLOG
====================== */

export function getBlogs() {
    return getCMSData()?.blogs?.filter(b => b.isActive) || [];
}

/* ======================
   TEAMS
====================== */

export function getTeams() {
    return getCMSData()?.teams || [];
}

export function getTeamsByCategory(category) {
    return getTeams().filter(t => t.category === category);
}

/* ======================
   CLIENTS
====================== */

export function getClients() {
    return getCMSData()?.clients || [];
}

/* ======================
   CORPORATE HISTORIES
====================== */
export function getCorpHistories() {
    return getCMSData()?.corpHistories || [];
}

/* ======================
   GALLERIES
====================== */

export function getGalleries() {
    return getCMSData()?.galleries || [];
}

export function getGalleryByTag(tag) {
    return getGalleries().filter(g =>
        g.tags?.toLowerCase().includes(tag.toLowerCase())
    );
}

/* ======================
   RECRUITMENTS
====================== */
export function getRecruitments() {
    return getCMSData()?.recruitments || [];
}